<button type="button"
  id="zoomOut"
  class="toolbarButton zoomOut"
  title="Zoom Out"
  data-l10n-id="zoom_out">
  <svg style="width:24px;height:24px" viewBox="0 0 24 24">
    <path fill="currentColor" d="M19,13H5V11H19V13Z" />
  </svg>
  <span data-l10n-id="zoom_out_label">Zoom Out</span>
</button>
